import { FC } from "react";

import { chakra } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import Icon from "@components/Icon";
import { useRouter } from "@lib/router";
import { QUERY_PARAMS, ROUTES } from "@utils/constants";
import joinDefinedStringParts from "@utils/joinDefinedStringParts";

import { DeliveryMethod, OrderFields } from "../../../constants";
import useOrderFormik from "../../../hooks/useOrderFormik";
import getAddressString from "../../../utils/getAddressString";
import OrderInfoItem from "../OrderInfoItem";

const OrderInfoReceiver: FC = () => {
  const { t } = useTranslation();

  const {
    values: {
      [OrderFields.DELIVERY_METHOD]: deliveryMethod,
      [OrderFields.RECEIVER_NAME]: receiverName,
      [OrderFields.RECEIVER_EMAIL]: receiverEmail,
      [OrderFields.RECEIVER_PHONE_NUMBER]: receiverPhone,
      [OrderFields.RECEIVER_LOCKER_NAME]: receiverLockerName,
      [OrderFields.RECEIVER_STREET]: receiverStreet,
      [OrderFields.RECEIVER_HOUSE_NO]: receiverHouseNo,
      [OrderFields.RECEIVER_FLAT_NO]: receiverFlatNo,
      [OrderFields.RECEIVER_CITY]: receiverCity,
      [OrderFields.RECEIVER_ZIP_CODE]: receiverZipCode,
      [OrderFields.DESTINATION_COUNTRY_NAME]: receiverCountry,
      [OrderFields.RECEIVER_COMMENTS]: receiverComments,
    },
  } = useOrderFormik();

  const router = useRouter();

  const receiverAddressParams = {
    street: receiverStreet || undefined,
    houseNo: receiverHouseNo || undefined,
    flatNo: receiverFlatNo || undefined,
    city: receiverCity || undefined,
    zip: receiverZipCode || undefined,
    country: receiverCountry || undefined,
    comments: receiverComments || undefined,
  };

  const receiverAddress =
    deliveryMethod === DeliveryMethod.DoorToPudo || deliveryMethod === DeliveryMethod.PudoToPudo
      ? `${receiverLockerName}, ${receiverCountry}`
      : getAddressString(receiverAddressParams);

  const receiverAddressLocker =
    deliveryMethod === DeliveryMethod.DoorToPudo || deliveryMethod === DeliveryMethod.PudoToPudo
      ? getAddressString(receiverAddressParams)
      : "";


  const receiverDescription = (
    <>
      <chakra.p wordBreak="break-word">
        {`${joinDefinedStringParts([receiverName, receiverPhone], ", ")}, `}
        <chakra.span>{receiverEmail}</chakra.span>
      </chakra.p>
      <chakra.p>{receiverAddress}</chakra.p>
      <chakra.p fontSize="sm" color="gray.500">
        {receiverAddressLocker}
      </chakra.p>
    </>
  );

  const handleEditClick = () => {
    if (deliveryMethod === DeliveryMethod.PudoToPudo || deliveryMethod === DeliveryMethod.PudoToDoor) {
      router.push({ pathname: ROUTES.ORDER_SHIPMENT, query: { [QUERY_PARAMS.ORDER_RECEIVER_INFO]: "true" } });
      return;
    }
    router.push(ROUTES.ORDER_RECEIVER);
  };

  return (
    <OrderInfoItem
      id="order-receiver"
      title={t("order-summary-receiver")}
      description={receiverDescription}
      isFixedWidthTitle
      image={<Icon icon="profile" size="1.75rem" />}
      onEditClick={handleEditClick}
    />
  );
};
export default OrderInfoReceiver;
